import * as React from "react";
import { IIconProps } from "./Icon";

const Icon = (props: IIconProps) => (
  <svg
    width={props.width}
    style={props.style}
    height={props.width}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${props.className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
        style={{ fill: props.color }} 
        d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z"/>
  </svg>  
);

export default Icon;
